// extracted by mini-css-extract-plugin
export default {"wrapper":"options_wrapper__0clob","option":"options_option__OnOzu","iconWrapper":"options_iconWrapper__g6XX-","title":"options_title__HqlNL"};